import{create_ssr_component as k,validate_component as h,missing_component as g,escape as j}from"svelte/internal";import{setContext as C,afterUpdate as z,onMount as R,tick as S}from"svelte";let c="",m=c;const v={base:c,assets:m};function q(t){c=t.base,m=t.assets}function B(){c=v.base,m=v.assets}function E(t){m=v.assets=t}let G={},M={};function F(t){}function N(t){G=t}function H(t){M=t}let O=!1;function P(){}function T(){O=!0}const U=k((t,e,n,b)=>{let{stores:i}=e,{page:p}=e,{constructors:s}=e,{components:a=[]}=e,{form:l}=e,{data_0:d=null}=e,{data_1:f=null}=e;C("__svelte__",i),z(i.page.notify);let u=!1,_=!1,y=null;R(()=>{const o=i.page.subscribe(()=>{u&&(_=!0,S().then(()=>{y=document.title||"untitled page"}))});return u=!0,o}),e.stores===void 0&&n.stores&&i!==void 0&&n.stores(i),e.page===void 0&&n.page&&p!==void 0&&n.page(p),e.constructors===void 0&&n.constructors&&s!==void 0&&n.constructors(s),e.components===void 0&&n.components&&a!==void 0&&n.components(a),e.form===void 0&&n.form&&l!==void 0&&n.form(l),e.data_0===void 0&&n.data_0&&d!==void 0&&n.data_0(d),e.data_1===void 0&&n.data_1&&f!==void 0&&n.data_1(f);let r,w,x=t.head;do r=!0,t.head=x,i.page.set(p),w=`  ${s[1]?`${h(s[0]||g,"svelte:component").$$render(t,{data:d,this:a[0]},{this:o=>{a[0]=o,r=!1}},{default:()=>`${h(s[1]||g,"svelte:component").$$render(t,{data:f,form:l,this:a[1]},{this:o=>{a[1]=o,r=!1}},{})}`})}`:`${h(s[0]||g,"svelte:component").$$render(t,{data:d,form:l,this:a[0]},{this:o=>{a[0]=o,r=!1}},{})}`} ${u?`<div id="svelte-announcer" aria-live="assertive" aria-atomic="true" style="position: absolute; left: 0; top: 0; clip: rect(0 0 0 0); clip-path: inset(50%); overflow: hidden; white-space: nowrap; width: 1px; height: 1px">${_?`${j(y)}`:""}</div>`:""}`;while(!r);return w});function W(t){}function A(t){}const D={app_dir:"_app",app_template_contains_nonce:!1,csp:{mode:"auto",directives:{"upgrade-insecure-requests":!1,"block-all-mixed-content":!1},reportOnly:{"upgrade-insecure-requests":!1,"block-all-mixed-content":!1}},csrf_check_origin:!0,embedded:!1,env_public_prefix:"PUBLIC_",env_private_prefix:"",hooks:null,preload_strategy:"modulepreload",root:U,service_worker:!1,templates:{app:({head:t,body:e,assets:n,nonce:b,env:i})=>`<!doctype html>
<html
	lang="en"
	style="
		margin: 0;
		padding: 0;
		min-height: 100%;
		display: flex;
		flex-direction: column;
	"
>
	<head>
		<meta charset="utf-8" />
		<link rel="icon" href="/favicon.ico" />
		<meta name="viewport" content="width=device-width, initial-scale=1" />
		<meta property="og:title" content="Gradio" />
		<meta property="og:type" content="website" />
		<meta property="og:url" content="{url}" />
		<meta property="og:description" content="Click to try out the app!" />
		<meta
			property="og:image"
			content="https://raw.githubusercontent.com/gradio-app/gradio/main/js/_website/src/lib/assets/img/header-image.jpg"
		/>
		<meta name="twitter:card" content="summary_large_image" />
		<meta name="twitter:creator" content="@Gradio" />
		<meta name="twitter:title" content="Gradio" />
		<meta name="twitter:description" content="Click to try out the app!" />
		<meta
			name="twitter:image"
			content="https://raw.githubusercontent.com/gradio-app/gradio/main/js/_website/src/lib/assets/img/header-image.jpg"
		/>
		<script data-gradio-mode>
			window.__gradio_mode__ = "app";
			window.iFrameResizer = {
				heightCalculationMethod: "taggedElement"
			};
			window.parent?.postMessage(
				{ type: "SET_SCROLLING", enabled: false },
				"*"
			);
		<\/script>
		<script
			src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.1/iframeResizer.contentWindow.min.js"
			async
		><\/script>

		`+t+`
	</head>
	<body
		data-sveltekit-preload-data="hover"
		style="
			width: 100%;
			margin: 0;
			padding: 0;
			display: flex;
			flex-direction: column;
			flex-grow: 1;
		"
	>
		<div style="display: contents">`+e+`</div>
	</body>
</html>
`,error:({status:t,message:e})=>`<!doctype html>
<html lang="en">
	<head>
		<meta charset="utf-8" />
		<title>`+e+`</title>

		<style>
			body {
				--bg: white;
				--fg: #222;
				--divider: #ccc;
				background: var(--bg);
				color: var(--fg);
				font-family:
					system-ui,
					-apple-system,
					BlinkMacSystemFont,
					'Segoe UI',
					Roboto,
					Oxygen,
					Ubuntu,
					Cantarell,
					'Open Sans',
					'Helvetica Neue',
					sans-serif;
				display: flex;
				align-items: center;
				justify-content: center;
				height: 100vh;
				margin: 0;
			}

			.error {
				display: flex;
				align-items: center;
				max-width: 32rem;
				margin: 0 1rem;
			}

			.status {
				font-weight: 200;
				font-size: 3rem;
				line-height: 1;
				position: relative;
				top: -0.05rem;
			}

			.message {
				border-left: 1px solid var(--divider);
				padding: 0 0 0 1rem;
				margin: 0 0 0 1rem;
				min-height: 2.5rem;
				display: flex;
				align-items: center;
			}

			.message h1 {
				font-weight: 400;
				font-size: 1em;
				margin: 0;
			}

			@media (prefers-color-scheme: dark) {
				body {
					--bg: #222;
					--fg: #ddd;
					--divider: #666;
				}
			}
		</style>
	</head>
	<body>
		<div class="error">
			<span class="status">`+t+`</span>
			<div class="message">
				<h1>`+e+`</h1>
			</div>
		</div>
	</body>
</html>
`},version_hash:"9nh9zn"};async function J(){return{}}export{m as a,c as b,D as c,F as d,O as e,N as f,J as g,H as h,E as i,P as j,A as k,T as l,W as m,q as o,G as p,B as r,M as s};
//# sourceMappingURL=internal.js.map
